import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import SidebarLayout from "../../common/sidebar/SidebarLayout";
import CardLayout from "../../common/cardLayout/CardLayout";
import { getFullName, getInitials } from "../../../util/helpers";
import {
  fetchCaregiverDataLogic,
  fetchClinicAdminDataLogic,
} from "../../../store/features/patient/patientSlice";
import PatientLoader from "../../common/PatientLoader";
import {
  fetchRecentAssessmentsLogic,
  fetchScheduledAssessmentsLogic,
  fetchPendingAssessmentsLogic,
} from "../../../store/features/patient/assessmentsSlice";
import moment from "moment";
import "./caregiver.css";
import { NoAssessments } from "../patient/InfoTabs/FlaggedJournals";
import { isEmptyObject } from "jquery";
import { useNavigate } from "react-router-dom";
import { Helmet } from "../../common/Helmet";
import Select from "react-select";
import AssessmentModal from "./AssessmentModal";
import communicationWithTeen from "../../../assets/CaregiverArticles/Crafting Realistic Rules for Teenagers- A Proactive Approach.pdf";
import nurturingYourTeen from "../../../assets/CaregiverArticles/Nurturing Your Teen.pdf";
import parentingPreteens from "../../../assets/CaregiverArticles/Parenting Preteens.pdf";
import hopeforHardTime from "../../../assets/CaregiverArticles/Hope for Hard Times.pdf";
import culturalExpectations from "../../../assets/CaregiverArticles/Cultural Expectations.pdf";
import developmentalMilestone from "../../../assets/CaregiverArticles/Developmental Milestones.pdf";
import tipsforGuidingYourTeenager from "../../../assets/CaregiverArticles/Tips for Guiding Your Teenager.pdf";
import craftingRealisticRules from "../../../assets/CaregiverArticles/Crafting Realistic Rules for Teenagers- A Proactive Approach.pdf";
import morningWithMiddleSchoolers from "../../../assets/CaregiverArticles/Morning with Middle Schoolers.pdf";
import troubleshootingCommunication from "../../../assets/CaregiverArticles/Troubleshooting Communication With Your Teen.pdf";
import navigatingBoundaries from "../../../assets/CaregiverArticles/Navigating Boundaries for Your Preteen's Phone Usage.pdf";
import navigatingAnxiety from "../../../assets/CaregiverArticles/Navigating Anxiety.pdf";
import navigatingTeenageAnger from "../../../assets/CaregiverArticles/Navigating Teenage Anger.pdf";
import empoweringTraumatizedTeens from "../../../assets/CaregiverArticles/Empowering Traumatized Teens.pdf";
import recognizingTeenageDepression from "../../../assets/CaregiverArticles/Recognizing Teenage Depression.pdf";
import depressionConversationStarters from "../../../assets/CaregiverArticles/Depression Conversation Starters.pdf";
import teensandADHD from "../../../assets/CaregiverArticles/Teens and ADHD.pdf";
import diagnosingMentalHealthforTeens from "../../../assets/CaregiverArticles/Diagnosing Mental Health for Teens.pdf";
import teenMentalHealthTreatment from "../../../assets/CaregiverArticles/Teen Mental Health Treatment.pdf";
import healthyTeenRelationships from "../../../assets/CaregiverArticles/Healthy Teen Relationships.pdf";
import preteensAndCommunication from "../../../assets/CaregiverArticles/Preteens and Communication.pdf";
import identifyingAnxietyInTeens from "../../../assets/CaregiverArticles/Identifying Anxiety in Teens.pdf";
import loveHateDynamicWithTeens from "../../../assets/CaregiverArticles/Love Hate Dynamic with Teens.pdf";
import balancingGriefAndParenthood from "../../../assets/CaregiverArticles/Balancing Grief and Parenthood.pdf";

const CareGiver = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, user } = useSelector((state) => state.app);
  const {
    assessmentsLoading,
    recentAssessments,
    scheduledAssessments,
    pendingAssessmentsData,
  } = useSelector((state) => state.assessment);

  const [local_loading, setLoading] = useState(false);
  const [noTakenAssessments, setNoTakenAssessments] = useState(false);
  const [attemptAssessment, setAttemptAssessment] = useState(null);
  const [pending, setPending] = useState([]);
  const [currentAssessment, setCurrentAssessment] = useState(null);
  const [showAssessmentModal, setShowAssessmentModal] = useState(false);
  const [caregiverData, setCareGiverData] = useState(null);
  const [clinicAdmminData, setClinicAdmminData] = useState(null);
  const [cgName, setCGName] = useState("Anonymous");

  const originURL = window.location.origin;
  // useEffect(() => {
  //   if (user) {
  //     if (user?.role !== "CAREGIVER" || !originURL.includes("youth")) {
  //       if (originURL !== "http://localhost:3000") {
  //         navigate("/dashboard/home/");
  //       }
  //     }
  //   }
  // }, []);

  const resetDropdown = () => {
    setCurrentAssessment(null);
    setAttemptAssessment(null);
  };

  useEffect(() => {
    if (!assessmentsLoading && !isEmptyObject(recentAssessments)) {
      let counter = 0;
      Object.values(recentAssessments).forEach((item) => {
        if (item.length > 0) {
          counter += 1;
        }
      });
      setNoTakenAssessments(counter > 0);
    }
    console.log("recentAssessments: ", recentAssessments);
  }, [assessmentsLoading, recentAssessments]);

  useEffect(() => {
    setLoading(true);
    dispatch(fetchPendingAssessmentsLogic(user?.id));
    dispatch(fetchRecentAssessmentsLogic(user?.id));
    dispatch(fetchScheduledAssessmentsLogic(user?.id));
    fetchCaregiverDataLogic(user?.id)
      .then((res) => {
        if (res.status === 200) {
          setCGName(getFullName(res?.data));
          setCareGiverData(res?.data);
          fetchClinicAdminDataLogic(res?.data?.child?.clinician)
            .then((res) => {
              if (res.status === 200) {
                setClinicAdmminData(res?.data);
              }
            })
            .catch((e) => {
              console.log("Error fetching clinic admin data", e);
            });
        }
      })
      .catch((e) => {
        console.log("Error fetching caregiver data", e);
      });

    setLoading(false);
  }, []);

  useEffect(() => {
    if (!loading) {
      if (pendingAssessmentsData.length > 0) {
        const temp = pendingAssessmentsData.map((item) => {
          return {
            label: item?.name,
            value: item,
          };
        });
        setPending(temp);
      }
    }
  }, [pendingAssessmentsData]);

  useEffect(() => {
    if (currentAssessment) {
      setShowAssessmentModal(true);
    } else {
      setShowAssessmentModal(false);
    }
    console.log("Assessment2", currentAssessment);
  }, [currentAssessment]);

  const MaterialPill = ({ text, link = "", disabled = false }) => {
    return (
      <div className="material-pill mb-3">
        <label>{text}</label>
        <div className="d-flex" style={{ gap: "10px" }}>
          {!disabled ? (
            <a
              href={link}
              style={{ borderRadius: "8px" }}
              className="btn primary-btn "
              target="_blank"
            >
              View
            </a>
          ) : (
            <a
              href={link}
              style={{ borderRadius: "8px" }}
              className="btn primary-btn disabled"
              target="_blank"
            >
              View
            </a>
          )}

          <a
            href={link}
            style={{ borderRadius: "8px" }}
            className="btn primary-btn"
            target="_blank"
            download
          >
            Download
          </a>
        </div>
      </div>
    );
  };

  return (
    <>
      <SidebarLayout>
        <AssessmentModal
          data={currentAssessment}
          modalIsOpen={showAssessmentModal}
          setIsOpen={setShowAssessmentModal}
          resetDropdown={resetDropdown}
        />
        <section className="container-fluid">
          <Helmet>
            <meta charSet="utf-8" />
            <title>Patient Assesssments | Precise Digital</title>
            <link rel="canonical" href={window.location.origin} />
          </Helmet>
          {local_loading || loading || assessmentsLoading ? (
            <PatientLoader />
          ) : (
            <CardLayout className="p-3 container-fluid w-100">
              <div className="row container-fluid w-100">
                <div className="col-sm-12 col-md-3 col-lg-3 p-3 text-center">
                  <img
                    height="125px"
                    width="125px"
                    alt="Patient's DP"
                    style={{ borderRadius: "100%", padding: "0.2rem" }}
                    src={
                      caregiverData?.profile_picture ||
                      `https://placehold.co/70x70/f1f1f5/395E9D/?text=${getInitials(
                        cgName
                      )}`
                    }
                  />
                </div>
                <div
                  className="col-sm-12 col-md-3 col-lg-3 p-3"
                  style={{ borderLeft: "1px solid lightgray" }}
                >
                  <h5>CareGiver Details</h5>
                  <br />
                  <div className="form-group d-flex" style={{ gap: "10px" }}>
                    <label>First Name</label>
                    <span>{caregiverData?.first_name}</span>
                  </div>
                  <div className="form-group d-flex" style={{ gap: "10px" }}>
                    <label>Last Name</label>
                    <span>{caregiverData?.last_name}</span>
                  </div>
                  <div className="form-group d-flex" style={{ gap: "10px" }}>
                    <label>Email Address</label>
                    <span>{caregiverData?.email || "Unavailable"}</span>
                  </div>
                </div>
                <div
                  className="col-sm-12 col-md-3 col-lg-3 p-3"
                  style={{ borderLeft: "1px solid lightgray" }}
                >
                  <h5>Care Details</h5>
                  <br />
                  <div className="form-group d-flex" style={{ gap: "10px" }}>
                    <label>Name</label>
                    <span>
                      {user?.first_name} {user?.last_name}
                    </span>
                  </div>
                  <div className="form-group d-flex" style={{ gap: "10px" }}>
                    <label>Date Of Birth</label>
                    <span>
                      {caregiverData?.child?.date_of_birth || "Unavailable"}
                    </span>
                  </div>
                </div>
                <div
                  className="col-sm-12 col-md-3 col-lg-3 p-3"
                  style={{ borderLeft: "1px solid lightgray" }}
                >
                  <h5>Your Child's Care Team</h5>
                  <br />
                  <div className="form-group d-flex" style={{ gap: "10px" }}>
                    <label>Provider Name</label>
                    <span>
                      {clinicAdmminData?.first_name}{" "}
                      {clinicAdmminData?.last_name}
                    </span>
                  </div>
                </div>
              </div>
            </CardLayout>
          )}

          {local_loading || loading || assessmentsLoading ? (
            <PatientLoader />
          ) : (
            <CardLayout className="p-3 container-fluid w-100 my-4">
              <div className="text-center container-fluid w-100">
                <h3 className="primary-text-blue">
                  Screen for Child Anxiety Related Disorders
                </h3>
              </div>

              {/* scheduledAssessments */}
              {pendingAssessmentsData.length > 0 && (
                <div className="container-fluid mb-4 w-100">
                  <div className="row">
                    <div className="col-12 col-md-10">
                      <Select
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            border: "0px",
                            borderBottom: "1px solid #94A3B8",
                            borderRadius: "0px",
                            padding: "5px",
                            width: "100%",
                          }),
                        }}
                        components={{
                          IndicatorSeparator: () => null,
                        }}
                        placeholder="Select a pending assessment to complete!"
                        classNamePrefix="Select a pending assessment to complete!"
                        value={attemptAssessment}
                        onChange={(e) => {
                          console.log("Assessment", e);
                          setAttemptAssessment(e);
                        }}
                        options={pending}
                      />
                    </div>
                    <div className="col-12 col-md-2 mt-3 mt-md-0">
                      <button
                        onClick={() => {
                          setCurrentAssessment(attemptAssessment?.value);
                          console.log(
                            "Assessment1",
                            currentAssessment?.questionnaire?.length
                          );
                        }}
                        className="primary-btn w-100"
                      >
                        Begin Assessment
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {pendingAssessmentsData.length === 0 && (
                <NoAssessments
                  show_link={false}
                  text="No scheduled assessments!"
                />
              )}
            </CardLayout>
          )}

          {local_loading || loading || assessmentsLoading ? (
            <PatientLoader />
          ) : (
            <CardLayout className="p-3 container-fluid w-100  my-4">
              <h3 className="primary-text-blue">Assessments Taken Recently</h3>

              {!noTakenAssessments ? (
                <NoAssessments
                  show_link={false}
                  text="No recent assessments taken!"
                />
              ) : (
                <div
                  className="d-flex w-100"
                  style={{
                    alignContent: "center",
                    alignItems: "start",
                    justifyContent: "start",
                  }}
                >
                  {Object.keys(recentAssessments)
                    .filter((item) => {
                      if (recentAssessments[item].length > 0) {
                        return item;
                      }
                    })
                    .map((assessment, index) => {
                      return (
                        <div
                          key={index}
                          className="mx-2"
                          style={{
                            borderRadius: "8px",
                            border: "1px solid lightgray",
                            padding: "1% 2%",
                            width: "fit-content",
                          }}
                        >
                          <h4 className="primary-text-blue">{assessment}</h4>
                          <label className="d-flex" style={{ gap: "10px" }}>
                            <strong>Date Taken</strong> :{" "}
                            <span>
                              {moment(
                                recentAssessments[assessment][0]?.modified
                              ).format("MM/DD/YYYY")}
                            </span>
                          </label>
                        </div>
                      );
                    })}
                </div>
              )}
            </CardLayout>
          )}

          {local_loading || loading || assessmentsLoading ? (
            <PatientLoader />
          ) : (
            <CardLayout className="p-3 container-fluid w-100">
              <h3 className="primary-text-blue">Articles for Caregivers</h3>
              <div className="container-fluid py-2">
                <strong style={{ color: "#1E293B" }}>
                  <div className="container-fluid py-3 ">
                    <MaterialPill
                      text={"Communication with Teens"}
                      link={communicationWithTeen}
                    />
                    <MaterialPill
                      text={"Nurturing Your Teen"}
                      link={nurturingYourTeen}
                    />
                    <MaterialPill
                      text={"Parenting Preteens"}
                      link={parentingPreteens}
                    />
                    <MaterialPill
                      text={"Hope for Hard Time"}
                      link={hopeforHardTime}
                    />
                    <MaterialPill
                      text={"Cultural Expectations"}
                      link={culturalExpectations}
                    />
                    <MaterialPill
                      text={"Developmental Milestones"}
                      link={developmentalMilestone}
                    />
                    <MaterialPill
                      text={"Healthy Teen Relationships"}
                      link={healthyTeenRelationships}
                    />
                    <MaterialPill
                      text={"Tips for Guiding Your Teenager"}
                      link={tipsforGuidingYourTeenager}
                    />
                    <MaterialPill
                      text={
                        "Crafting Realistic Rules for Teenagers- A Proactive Approach"
                      }
                      link={craftingRealisticRules}
                    />
                    <MaterialPill
                      text={"Morning with Middle Schoolers"}
                      link={morningWithMiddleSchoolers}
                    />
                    <MaterialPill
                      text={"Troubleshooting Communication With Your Teen"}
                      link={troubleshootingCommunication}
                    />
                    <MaterialPill
                      text={"Preteens and Communication"}
                      link={preteensAndCommunication}
                    />
                    <MaterialPill
                      text={"Love Hate Dynamic with Teens Anxiety"}
                      link={loveHateDynamicWithTeens}
                    />
                    <MaterialPill
                      text={"Balancing Grief and Parenthood"}
                      link={balancingGriefAndParenthood}
                    />
                    <MaterialPill
                      text={
                        "Navigating Boundaries for Your Preteen's Phone Usage"
                      }
                      link={navigatingBoundaries}
                    />
                    <MaterialPill
                      text={"Identifying Anxiety in Teens"}
                      link={identifyingAnxietyInTeens}
                    />
                    <MaterialPill
                      text={"Navigating Anxiety"}
                      link={navigatingAnxiety}
                    />
                    <MaterialPill
                      text={"Navigating Teenage Anger"}
                      link={navigatingTeenageAnger}
                    />
                    <MaterialPill
                      text={"Identifying Anxiety in Teens"}
                      link={identifyingAnxietyInTeens}
                    />
                    <MaterialPill
                      text={"Empowering Traumatized Teens"}
                      link={empoweringTraumatizedTeens}
                    />
                    <MaterialPill
                      text={"Recognizing Teenage Depression"}
                      link={recognizingTeenageDepression}
                    />
                    <MaterialPill
                      text={"Depression Conversation Starters"}
                      link={depressionConversationStarters}
                    />
                    <MaterialPill text={"Teens and ADHD"} link={teensandADHD} />
                    <MaterialPill
                      text={"Diagnosing Mental Health for Teens"}
                      link={diagnosingMentalHealthforTeens}
                    />
                    <MaterialPill
                      text={"Teen Mental Health Treatment"}
                      link={teenMentalHealthTreatment}
                    />
                    {/* <MaterialPill text={"Morning with Middle Schoolers"} link={nurturing} /> */}
                  </div>
                </strong>
              </div>
            </CardLayout>
          )}
        </section>
      </SidebarLayout>
    </>
  );
};

export default CareGiver;
